import React from 'react';
import { Trans } from 'react-i18next';
import { setLocalSessionData } from '../../../../../utils/Authentication/handleUserSession';
import { LOCALSESSIONDATAKEYS, QUERY_PARAMS, SIGNUPTYPE } from '../../../../../constants/AppConstants';
import { WebCustomerRoutePaths } from '../../../../../constants/Routes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import EasyPayPlanContent from './Content/Content';
import './EasyPayPlan.css'

const EasyPayPlan = (props) => {
    const {source} = props
    const history = useHistory();

    const handleRedirect = () => {
        setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, SIGNUPTYPE.BROTHER_PLUS);
        if(source === "landing-page"){
            history.push(`${WebCustomerRoutePaths.SELECT_PRINTER}?src=${QUERY_PARAMS.BROTHER_PLUS_SRC}&plan=${QUERY_PARAMS.BROTHER_PLUS_FREE_PLAN}`)
        }
        else{
            const redirectInfo = {
              pathname: WebCustomerRoutePaths.WEB_REDIRECT,
              state: { signupType: SIGNUPTYPE.BROTHER_PLUS }
            };
            history.push(redirectInfo);
        }
      };

    return (
        <div className='easy-pay-container'>
            <div className='try-new-benefit body-large'>
                {<Trans i18nKey="BROTHER_PLUS.EASY_PAY_BANNER.TRY_NEW_BENEFIT">
                    Not ready to commit yet? Try our <span className='easy-pay-new'>new</span> <span className='easy-pay-benefit'>benefits membership for free!</span>
                </Trans>}
            </div>
            <div className='easy-pay-wrapper'>
                <EasyPayPlanContent 
                    showTermsAndConditions = {false} 
                    showSkip = {false} 
                    showGetStartedBtn = {false}
                    showGetStartedBtnLandingPage = {true}
                    handleGetStartedLandingPage = {handleRedirect}
                />
            </div>
        </div>
    );
};

export default EasyPayPlan;